import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

const prepaidInventoryTransferBetweenStoresStyle = {
	...customSelectStyle
};

export default prepaidInventoryTransferBetweenStoresStyle;
